import Input from '@usas/ui-web/components/inputs/Input';
import ReadOnly from '@usas/ui-web/components/readOnly/ReadOnly';
import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';
import StatesCombobox from '@usas/ui-web/components/comboboxes/statesCombobox/StatesCombobox';
import AddressValidation from '@usas/ui-web/components/addressValidation/AddressValidation';
import ClubAffiliationTypeMultiselect from '@usas/ui-web/components/multiSelect/clubAffTypeMultiSelect/ClubAffiliationTypeMultiselect';

import global from '@usas/ui-web/components/GlobalStyle.module.css';
import OfferingTypeRegistrationRadiobuttonList from '../../../components/radiobuttonlists/OfferingTypeRegistrationRadiobuttonList';

const ClubRegistrationInfoWrite = ({ state, handleSubmit, formState, errorState, onValueTextPairChanged,
  onFormValueChanged, settingOptions, setFormData, isReuseClub, clubOwnerTypeState }) => (
  <div className={state.showPage === true ? global.DisplayComponent : global.HideComponent}>
    <form onSubmit={handleSubmit} noValidate>
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          {(isReuseClub === true && formState.hasNewClubRegistrationRec === false) &&
            <OfferingTypeRegistrationRadiobuttonList
              label={"Select a Offering Type"}
              name={"offeringInstanceId"}
              error={errorState.offeringInstanceId}
              message={errorState.offeringInstanceId}
              value={formState.offeringInstanceId}
              isVertical={true}
              onChange={(value) => { onFormValueChanged('offeringInstanceId', parseInt(value)) }}
              orgUnitId={formState.orgUnitId}
              isOrganizationRegistration={false}
            />
          }
        </div>
      </div>
      <div className={formState.offeringInstanceId !== -1 ? global.DisplayComponent : global.HideComponent}>
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-4">
            {state.isClubCreated === false ?
              <Input
                label="Club Name*"
                name="clubName"
                value={formState.clubName}
                error={errorState.clubName}
                message={errorState.clubName}
                onChange={(value) => { onFormValueChanged('clubName', value) }} />
              :
              <ReadOnly
                label="Club Name*"
                name="clubName"
                value={formState.clubName} />
            }
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            {state.isClubCreated === false ?
              <Input
                label="Club Code*"
                name="clubCode"
                value={formState.clubCode}
                error={errorState.clubCode}
                message={errorState.clubCode}
                onChange={(value) => { onFormValueChanged('clubCode', value) }} />
              :
              <ReadOnly
                label="Club Code*"
                name="clubCode"
                value={formState.clubCode} />
            }
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <ReadOnly
              label="LSC"
              name="lscName"
              value={formState.lscName}
            />
          </div>
        </div>
        <div className="row">

          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="Year Founded"
              name="yearFounded"
              value={formState.yearFounded}
              error={errorState.yearFounded}
              message={errorState.yearFounded}
              onChange={(value) => { onFormValueChanged('yearFounded', value) }} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-4">
            {(
              isReuseClub === false &&
              clubOwnerTypeState.isLoaded === false) ||
              formState.hasNewClubRegistrationRec === true ?
              <ReadOnly
                label="Owner Type"
                name="ownerTypeName"
                value={formState.ownerTypeName}
              />
              :
              <Dropdown
                label="Owner Type*"
                options={clubOwnerTypeState.dataAsOptionsWithNames}
                name="clubOwnerTypeId"
                areValuesIntegers={true}
                value={formState.clubOwnerTypeId}
                error={errorState.clubOwnerTypeId}
                message={errorState.clubOwnerTypeId}
                isLoading={clubOwnerTypeState.isLoading}
                onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'clubOwnerTypeId', newValueLabel, 'ownerTypeName', e); }}
              />
            }
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <ReadOnly
              label="Club Type"
              name="clubTypeName"
              value={formState.clubTypeName}
            />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            {(
              // formState.clubTypeName === 'Non-Profit/Board' || 
              formState.ownerTypeName === 'Other' || 
              formState.ownerTypeName === 'Non-Profit Corporation'
            ) ?
              <Input
                label="Number of board members*"
                name="numberOfBoardMembers"
                value={formState.numberOfBoardMembers}
                error={errorState.numberOfBoardMembers}
                message={errorState.numberOfBoardMembers}
                onChange={(value) => { onFormValueChanged('numberOfBoardMembers', value) }} />
              :
              <ReadOnly
                label="Number of board members"
                name="numberOfBoardMembers"
                value="N/A" />
            }
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-4">
            <ReadOnly
              label="Tax Listing"
              name="businessEntityTypeName"
              value={formState.businessEntityTypeName} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Dropdown
              label="Setting"
              options={settingOptions}
              name="clubSetting"
              value={formState.clubSetting}
              error={errorState.clubSetting}
              message={errorState.clubSetting}
              onChange={(value) => { onFormValueChanged('clubSetting', value) }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="Primary Mailing Club Address*"
              name="address1"
              value={formState.address1}
              error={errorState.address1}
              message={errorState.address1}
              onChange={(value) => { onFormValueChanged('address1', value) }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="Address Line 2"
              name="address2"
              value={formState.address2}
              error={errorState.address2}
              message={errorState.address2}
              onChange={(value) => { onFormValueChanged('address2', value) }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="City*"
              name="city"
              value={formState.city}
              error={errorState.city}
              message={errorState.city}
              onChange={(value) => { onFormValueChanged('city', value) }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <StatesCombobox
              label="State*"
              name="stateCode"
              valueToMatch={formState.stateName}
              error={errorState.stateCode}
              message={errorState.stateCode}
              isUSA={true}
              onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'stateCode', newValueLabel, 'stateName', e); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="Zip Code*"
              name="postalCode"
              value={formState.postalCode}
              error={errorState.postalCode}
              message={errorState.postalCode}
              onChange={(value) => { onFormValueChanged('postalCode', value) }} />
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6">
            <Input
              label="Website Address"
              name="websiteAddress"
              value={formState.websiteAddress}
              error={errorState.websiteAddress}
              message={errorState.websiteAddress}
              onChange={(value) => { onFormValueChanged('websiteAddress', value) }} />
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12">
            <ClubAffiliationTypeMultiselect
              label="Club Affiliation Types"
              name="clubAffiliationTypes"
              value={formState.clubAffiliationTypes}
              error={errorState.clubAffiliationTypes}
              message={errorState.clubAffiliationTypes}
              onChange={(value) => { onFormValueChanged('clubAffiliationTypes', value) }} />
          </div>
          <AddressValidation formState={formState} setFormData={setFormData} />
        </div>
      </div>
    </form>
  </div>
)

export default ClubRegistrationInfoWrite;